import React from 'react'

const shimmer = {
  background: 'linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.09) 50%, rgba(255,255,255,0.03) 75%)',
  backgroundSize: '200% 100%',
  animation: 'skeleton-shimmer 1.6s ease-in-out infinite',
  borderRadius: '8px',
}

const Bar = ({ w = '100%', h = 14, mt = 0, mb = 0, r = 8 }) => (
  <div style={{ ...shimmer, width: w, height: h, marginTop: mt, marginBottom: mb, borderRadius: r }} />
)

const glass = {
  borderRadius: '14px',
  background: 'rgba(255,255,255,0.02)',
  border: '1px solid rgba(255,255,255,0.06)',
  padding: '20px 24px',
}

const SingleProjectSkeleton = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>

    {/* back btn */}
    <Bar w='140px' h={36} r={10} />

    {/* title card */}
    <div style={{ ...glass, background: 'rgba(250,204,21,0.03)', border: '1px solid rgba(250,204,21,0.08)' }}>
      <Bar w='55%' h={28} mb={10} r={8} />
      <Bar w='35%' h={14} r={6} />
    </div>

    {/* slider */}
    <Bar h={260} r={14} />

    {/* tech + links */}
    <div style={{ ...glass, display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
      {[80, 90, 70, 100, 75, 85].map((w, i) => (
        <Bar key={i} w={`${w}px`} h={28} r={20} />
      ))}
    </div>

    {/* description */}
    <div style={glass}>
      <Bar w='30%' h={16} mb={18} r={6} />
      <Bar h={13} mb={8} />
      <Bar h={13} mb={8} />
      <Bar w='75%' h={13} />
    </div>

    {/* features */}
    <div style={glass}>
      <Bar w='25%' h={16} mb={18} r={6} />
      {[1, 2, 3, 4].map((i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
          <Bar w='20px' h={20} r={50} />
          <Bar w={`${60 + i * 8}%`} h={12} />
        </div>
      ))}
    </div>

  </div>
)

export default SingleProjectSkeleton
